import {connect} from 'react-redux';
import SalesInformation from 'app/components/RightBarPane/Property/SalesInformation';

export const mapStateToProps = (state) => ({
    lastSale: state.getIn(['property', 'selectedProperty', 'lastSale']),
});

export default connect(mapStateToProps)(SalesInformation);